import { createAction, props } from '@ngrx/store';
import { IItineraryHistory } from 'src/app/core/models/itinerary-history.model';
import { ContractError } from 'src/app/core/models/models';
import { Operation } from 'src/app/core/models/operation-log.model';
import { StepResult } from 'src/app/core/models/Step-Result.model';

export const LoadOperationsSuccess = createAction(
  '[Operation Log] Load operations success ',
  props<{ operations: Operation[] }>()
);

export const LoadOperationsFail = createAction(
  '[Operation Log] Load operations fail ',
  props<{ error: ContractError }>()
);

export const LoadPNRHistory = createAction('[Operation Log] Load PNR History ');

export const LoadPNRHistorySuccess = createAction(
  '[Operation Log] Load PNR History Success',
  props<{ history: string }>()
);

export const LoadPNRItineraryHistorySuccess = createAction(
  '[Operation Log] Load PNR Itinerary History Success',
  props<{ itineraryHistory: StepResult[] }>()
);

export const LoadAirCompanyNotesSuccess = createAction(
  '[Operation Log] Load PNR Air Company Notes Success',
  props<{ airCompanyNotes: string }>()
);
